import { State } from '@app/store/state';

import { EXPERIENCE_TYPES } from './domain';

export const getExperienceType = (state: State) =>
  state.eventWizard.formData.template;

export const getEventName = (state: State) =>
  state.eventWizard.formData.basicDetails.name;

export const getTimeStart = (state: State) =>
  state.eventWizard.formData.basicDetails.timeStart;

export const getTimeEnd = (state: State) =>
  state.eventWizard.formData.basicDetails.timeEnd;

export const getEventLocationName = (state: State) =>
  state.eventWizard.formData.basicDetails.eventLocation.name;

export const getEventLocationAddress = (state: State) =>
  state.eventWizard.formData.basicDetails.eventLocation.address;

export const getVenue = (state: State) => state.eventWizard.venue;

export const hasNoVenueAreasSelected = (state: State) => {
  const venue = getVenue(state);
  return Object.entries(venue).every(([_, area]) => !area.selected); // Check if all visible areas are not selected
};

export const isWebinarExperience = (state: State) =>
  state.eventWizard.formData.template === EXPERIENCE_TYPES.WEBINAR;

export const getDescription = (state: State) =>
  state.eventWizard.formData.description;

export const getOrganizationFeatures = (state: State) =>
  state.eventWizard.organization.features;

export const getTimezone = (state: State) =>
  state.eventWizard.formData.timezone;

export const getEventCreationStatus = (state: State) =>
  state.eventWizard.eventCreation.status;

export const getEventCreationFormData = (state: State) =>
  state.eventWizard.formData;

export const getEventSeries = (state: State) => state.eventWizard.eventSeries;

export const getOrgPaymentPlanName = (state: State) =>
  state.eventWizard.organization.paymentPlan.planName;

export const getMaxEventLength = (state: State) =>
  state.eventWizard.organization.features.maxEventLengthHours;
